export const toggleButtons = [
  {
    id: "give",
    title: "Give",
    defaultValue: "a mentor",
  },
  {
    id: "inkind",
    title: "In kind",
    defaultValue: "Training",
  },
  {
    id: "join",
    title: "Join",
    defaultValue: "learner",
  },
];
export const cashButtons = [
  {
    id: 1,
    title: "Sponsor a mentor",
    code: "a mentor",
    text: "EAGLE significantly appreciates any contribution towards the work we are doing. If you would like to partner with us by sponsoring a mentor, please fill out the short form here and we will be in touch with more information. ",
  },
  {
    id: 2,
    title: "Sponsor a learner",
    code: "a learner",
    text: "EAGLE significantly appreciates any contribution towards the work we are doing. If you would like to partner with us by sponsoring a learner, please fill out the short form here and we will be in touch with more information. ",
  },
  {
    id: 3,
    title: "Start a new site",
    code: "a new site",
    text: "EAGLE significantly appreciates any contribution towards the work we are doing. If you would like to partner with us by starting a new site, please fill out the short form here and we will be in touch with more information. ",
  },
  {
    id: 4,
    title: "Give resources",
    code: "with new resources",
    text: "EAGLE significantly appreciates any contribution towards the work we are doing. If you would like to partner with us by starting a new site, please fill out the short form here and we will be in touch with more information. ",
  },
];

export const kindButtons = [
  {
    id: 1,
    title: "Training",
    text: "EAGLE’s mission is to equip unqualfied passionate individuals to be mentors and coaches within their local communities. In doing this, EAGLE is looking for partners that have rich resources and provide relevant training opportunities to empower mentors and coaches to grow in their professional spaces. If you think you may be a potential partner, please connect with us by filling our this short form. We would love to be in touch. ",
  },
  {
    id: 2,
    title: "Camps/Clinics",
    text: "Significant learning and growth happens when individuals are out of their comfort zone, experiencing new things in new ways. Camps and clinics are prime spaces for this which is why they are a huge priority for EAGLE. If you are interested in hosting a camp or clinic or have resources for either, please connect with us by filling our this short form. We would love to be in touch.",
  },
  {
    id: 3,
    title: "Holiday clubs",
    text: "The holidays are a fantastic time to engage kids and make an impact in their lives. As EAGLE, we are looking for partners that have rich resources and/or provide relevant learning opportunities for short time periods that make a long-term difference on lives. If you think you may be a potential partner, please connect with us by filling our this short form. We would love to be in touch.",
  },
  {
    id: 4,
    title: "Other actives",
    text: "The essence of EAGLE is to create connections between great learning experiences and underpriviledged communities that do not have access to high quality learning experiences. If you think you have the expertise, resources or capacity to partner together to make a significant difference in the next generation, please connect with us by filling our this short form. We would love to be in touch.",
  },
];

export const joinButtons = [
  {
    id: 1,
    title: "Join as a learner",
    code: "learner",
    text: "If you are interested in learning and growing in character, 21st century skills and essential literacys, you have come to the right place. EAGLE LEarning takes many forms based on your needs and your learning space. ",
  },
  {
    id: 2,
    title: "Join as a mentor",
    code: "mentor",
    text: "Whether you have education qualification or not, we love that you are interested in becoming an EAGLE mentor. In the application, process we intentionall look for individuals who are passionate about learning and are commited, capable indviduals who love God and have a heart for the next generation.",
  },
  {
    id: 3,
    title: "Join as a team volunteer",
    code: "volunteer",
    text: "EAGLE is all about learning, which is why volunteering is something we promote - there is no better learning than learning by doing. Whether its volunteering for a few weeks or several months, you will have unqiue opportunities to learn and grow, gaining professional skills and exposure to new ways of learning and apporaches to making holistic impact.",
  },
];
